import { DateTime } from "luxon";
import { formatDateTime } from "../../metric/RouteUtils";

/**
     * Formats the given time in milliseconds.
     * @param {number | undefined} t - The time to format.
     * @returns {string} Formatted time.
     */
export const prettyTimeDesktop = ( t: number | undefined ): string =>
{
    if ( t === undefined || t === 0 ) return "";

    return formatDateTime( DateTime.fromMillis( t ) );
};

/**
     * Formats the given time in milliseconds for the provided hour and timezone.
     * @param {number | undefined} t - The time to format.
     * @returns {string} Formatted time.
     */
export const prettyTimeMobile = ( t: number | undefined ): string =>
{
    if ( t === undefined || t === 0 ) return "";

    return DateTime.fromMillis( t ).toFormat( "hh:mm a ZZZZ" );
};

